import {UserPermissions} from '../../shared/enums/UserPermissions.enum';

export class ReadWritePermissions {

  public read: boolean;
  public modify: boolean;

  constructor(read: boolean, modify: boolean) {
    this.read = read;
    this.modify = modify;
  }
}

export class CurrentUserPermissions {

  public doors: ReadWritePermissions;
  public usersAndCards: ReadWritePermissions;
  public visitors: ReadWritePermissions;
  public operators: ReadWritePermissions;
  public lockdown: ReadWritePermissions;
  public events: ReadWritePermissions;
  public networks: ReadWritePermissions;
  public reports: ReadWritePermissions;
  public autoLogoutTimeoutInMinutes: number;

  constructor(jwtObj) {
    this.doors = new ReadWritePermissions(
      jwtObj.manualOutputGroups === UserPermissions.Modify || jwtObj.manualOutputGroups === UserPermissions.Read,
      jwtObj.manualOutputGroups === UserPermissions.Modify
    );

    this.usersAndCards = new ReadWritePermissions(
      jwtObj.usersAndCards === UserPermissions.Modify || jwtObj.usersAndCards === UserPermissions.Read,
      jwtObj.usersAndCards === UserPermissions.Modify
    );
    this.visitors = new ReadWritePermissions(
      jwtObj.visitors === UserPermissions.Modify || jwtObj.visitors === UserPermissions.Read,
      jwtObj.visitors === UserPermissions.Modify
    );
    this.operators = new ReadWritePermissions(
      jwtObj.operators === UserPermissions.Modify || jwtObj.operators === UserPermissions.Read,
      jwtObj.operators === UserPermissions.Modify
    );
    this.lockdown = new ReadWritePermissions(
      jwtObj.lockdown === UserPermissions.Modify || jwtObj.lockdown === UserPermissions.Read,
      jwtObj.lockdown === UserPermissions.Modify
    );
    this.events = new ReadWritePermissions(
      jwtObj.events === UserPermissions.Modify || jwtObj.events === UserPermissions.Read,
      jwtObj.events === UserPermissions.Modify
    );
    this.networks = new ReadWritePermissions(
      jwtObj.networks === UserPermissions.Modify || jwtObj.networks === UserPermissions.Read,
      jwtObj.networks === UserPermissions.Modify
    );
    this.reports = new ReadWritePermissions(
      jwtObj.reports === UserPermissions.Modify || jwtObj.reports === UserPermissions.Read,
      jwtObj.reports === UserPermissions.Modify
    );
    this.autoLogoutTimeoutInMinutes = jwtObj.autoLogoutTimeoutInMinutes;
  }

}

